import React from 'react';
import { NextPage, NextPageContext } from 'next';
import { NotFound } from '../features/Layout/NotFound';
import { getLanguage } from '../utils/getLanguage';
import { useContentfulLiveUpdates } from '@contentful/live-preview/react';
import { expand } from '../features/Contentful/api/utils';
import * as contentful from 'contentful';
import { fetchRawPreviewData } from '../features/Contentful';
import { ArticleTemplate } from '../features/Template/ArticleTemplate';

type PreviewParams = {
  initialData?: // @ts-ignore
  | contentful.EntryCollection<EntryType, undefined, string>
    // @ts-ignore
    | contentful.EntryCollection<EntryType, 'WITHOUT_LINK_RESOLUTION', string>;
  hero?: boolean;
};

export const PreviewLandingPage: NextPage<PreviewParams> = ({
  initialData,
}) => {
  const data = useContentfulLiveUpdates(initialData);
  const item = data?.items[0];

  if (!item) {
    return <NotFound />;
  }

  // format the raw module data
  const articlePage = expand(
    item.sys.id,
    item.sys.contentType.sys.id,
    item.fields,
  );

  if (!articlePage) {
    return <NotFound />;
  }

  return <ArticleTemplate {...articlePage} />;
};

PreviewLandingPage.getInitialProps = async (
  ctx: NextPageContext,
): Promise<PreviewParams> => {
  const { id, hero, locale } = ctx.query as {
    id: string;
    hero?: string;
    locale?: string;
  };
  let initialData = null;
  if (id) {
    initialData = await fetchRawPreviewData(
      id,
      locale || getLanguage(ctx.locale!),
    );
  }
  return {
    initialData,
    hero: Boolean(hero),
  };
};

export default PreviewLandingPage;
